import { stringify } from 'query-string';
import { fetchMetrics } from '../helpers';

const removeEmptyKeys = (obj = {}) =>
  Object.keys(obj).reduce((acc, next) => {
    const val = obj[next];

    if (!val) {
      return acc;
    }

    return Object.assign({}, acc, {
      [next]: val,
    });
  }, {});

const setEventId = () => {
  const bigTimeRandom = Math.floor(Math.random() * 10000 + 1);
  const shortTimeRandom = Math.floor(Math.random() * 100 + 1);
  const time = new Date().getTime();

  return (bigTimeRandom + shortTimeRandom + time).toString();
};

const formatSaikaV3Event = ({ source, type, brand, data, references, context }) => {
  const body = {
    id: setEventId(),
    brand: brand,
    references: removeEmptyKeys(references),
    data: removeEmptyKeys(data),
  };
  const query = stringify(context);
  const url = `https://streams-collector-v1.b2w.io/event/${source}/${type}${query ? `?${query}` : query}`;
  fetchMetrics(url, JSON.stringify(body));
};

const parseComponents = components => {
  if (!components || typeof components !== 'object') {
    return null;
  }

  const pubs = [];
  const parse = parent => ({ children, crmkey }) => {
    if (crmkey) {
      pubs.push({ ...parent, crmkey });
    }

    if (children?.length > 0) {
      return children.forEach(parse(parent));
    }
  };

  Object.keys(components).forEach(key => {
    const publication = components[key];
    const { publicationId, type } = publication;
    const parent = {
      parent_position: key,
      parent_id: publicationId,
      parent_type: type,
    };

    publication.children?.forEach(parse(parent));
  });

  return pubs;
};

const pageLoad = detail => {
  const { project, product, navigation, mainOffer, servicesTokens, context, page } = detail;

  formatSaikaV3Event({
    source: 'site',
    type: 'page-visit',
    brand: project.brand,
    data: {
      url: navigation.url,
      path: navigation.pathname,
      page: page.type,
      type: page.type,
      productId: product ? product.id : '',
      mainOffer: mainOffer ? mainOffer.id : '',
      skuId: mainOffer ? mainOffer.sku : '',
      spacey: parseComponents(page.spaceyComponents),
    },
    references: {
      slugId: servicesTokens ? servicesTokens.turboToken : '',
      buyboxId: servicesTokens ? servicesTokens.buyboxToken : '',
    },
    context,
  });
};

const freightCalculate = detail => {
  const { project, freight, context } = detail;

  formatSaikaV3Event({
    source: 'freight',
    type: 'visualization',
    brand: project.brand,
    data: {
      origin: 'catalog',
    },
    references: {
      freightId: freight ? freight.id : '',
    },
    context,
  });
};

export const saikaInit = () => {
  document.addEventListener('page:load', ({ detail }) => {
    pageLoad(detail);
  });
  document.addEventListener('freight:calculate', ({ detail }) => {
    freightCalculate(detail);
  });
  document.addEventListener('freight:error', ({ detail }) => {
    freightCalculate(detail);
  });
};
